<template>
<div class="link-input-wrapper input-has-radius">
  <div
    ref="linkInput"
    contenteditable="true"
    :style="{ minHeight: minHeight || 0, borderColor: validateResult ? '#2088f3' : '#F14' }"
    :placeholder="placeholder"
    @blur="blurInput"
    @focus="focusInput"
    @mouseup="selectHandle"
  />
  <DeleteIcon
    v-show="wordCount > 0"
    class="input-delete-icon"
    @iconClick="emptyClick"
  />
  <span class="link-input-errorMsg" v-if="!validateResult">
    {{ errorMsg }}
  </span>
</div>
</template>

<script>
import DeleteIcon from '@/views/zhiji/bComponents/icons/DeleteIcon.vue';

// initValue:string, hasRadus:true|false, messages: {tips, error} tips输入时提示，error错误时提示
export default {
  name: 'LinkInput',
  components: {
    DeleteIcon,
  },
  props: ['placeholder', 'initValue', 'cmdParam', 'minHeight', 'urlType'],
  data () {
    return {
      value: this.initValue || '',
      savedRange: null,
      cmdData: this.cmdParam || [], // 画像参数
      isLocked: false,
      wordCount: 0,
      oldText: '',
      isOnComposition: false,
      validateResult: true, // 验证结果
      errorMsg: '', // 错误信息
    };
  },
  watch: {
    value (newVal) {
      if (!this.isLocked) {
        this.$refs.linkInput.innerHTML = newVal;
      }
    },
    urlType: {
      handler (newVal) {
        if (newVal !== 'outColor') {
          this.validateResult = true;
          this.errorMsg = '';
        }
      },
      deep: true,
    }
  },
  mounted () {
    this.$refs.linkInput.innerHTML = this.value;
    this.wordCount = this.$refs.linkInput.textContent.length;
    const dom = this.$refs.linkInput;
    dom.addEventListener('input', () => {
      if (this.isOnComposition) {
        return;
      }
      this.handleInput();
    }, false);
  },
  methods: {
    blurInput () {
      this.isLocked = false;
      this.validateLink();
    },
    focusInput () {
      this.isLocked = true;
    },
    emptyClick () {
      this.value = '';
      this.$refs.linkInput.innerHTML = '';
      this.wordCount = 0;
      this.$emit('inputChange', this.value);
    },
     // 获取光标
    getRange () {
      if (window.getSelection) {
        const sel = window.getSelection();
        if (sel.rangeCount > 0) {
          return sel.getRangeAt(0);
        }
      } else if (document.selection) {
        // IE兼容
        return document.selection.createRange();
      }
      return null;
    },
    selectHandle () {
      this.saveCurrentRange();
      // 取消高亮
      if (!this.savedRange.commonAncestorContainer) return;
      const selectedEle = this.savedRange.commonAncestorContainer.parentElement;
      if (selectedEle.nodeName === 'P' && selectedEle.getAttribute('type') === 'highlight') {
        this.$emit('clickLinkHigh', {
          id: selectedEle.id,
          type: selectedEle.getAttribute('type'),
        });
      }
    },
    saveCurrentRange () {
      // 保存当前光标与选区
      const range = this.getRange();
      this.savedRange = range;
    },
    handleInput () {
      this.saveCurrentRange();
      const contentStr = this.$refs.linkInput.textContent;
      this.wordCount = contentStr.length;
      this.oldText = this.$refs.linkInput.innerHTML;
      this.updateData(this.$refs.linkInput);
    },
    insertNode (node) {
      if (this.savedRange.commonAncestorContainer == undefined) return;
      this.savedRange.deleteContents();
      this.savedRange.insertNode(node);
      // 更新双向绑定数据
      this.updateData(this.$refs.linkInput);
      this.oldText = this.$refs.linkInput.innerHTML;
    },
    updateData (ele) {
      const data = this.htmlToServerData(ele);
      this.$emit('input', {
        linkWord: data.linkWord,
        text: data.text,
        value: ele.innerHTML,
        wordCount: this.wordCount,
        cmd: data.cmd,
      });
    },
    htmlToServerData (dom) {
      let text = '';
      let cmd = []; // 画像参数
      const params = dom.innerText.match(/[^{\}]+(?=})/g) || [];
      cmd = this.cmdData.filter((item) => params.indexOf(item.key) > -1);
      dom.childNodes.forEach((item) => {
        text += item.textContent.replace(/\n+$/g, ''); // 去除文本结尾原本存在的换行
      });
      return {
        text,
        cmd,
      };
    },
    // 验证链接
    validateLink () {
      if (this.urlType === 'outColor') {
        // 只有外部网页链接的时候需要验证链接是否正确
        const contentStr = this.$refs.linkInput.textContent;
        const checkHttp = /^(https|http):/;
        this.validateResult = checkHttp.test(contentStr);
        if (!this.validateResult) {
          this.errorMsg = this.$t("zhiji.knowlege.linkWordModal.validateTip");
        } else {
          this.errorMsg = '';
        }
        return this.validateResult;
      } else {
        this.validateResult = true;
        this.errorMsg = '';
        return true;
      }
    },
  },
};
</script>

<style scoped lang="less">
.link-input-wrapper {
    position: relative;
    width: 200px;
    margin-bottom: 12px;
    box-sizing: border-box;
    div {
        width: 100%;
        height: 100%;
        padding: 6px 36px 6px 8px;
        box-sizing: border-box;
        color: #41475e;
        font-size: 12px;
        outline: none;
        border: 1px solid #d8e4f0;
        background: #fff;
        border-radius: 4px;
        &:focus {
            border: 1px solid #2088f3;
        }
        &:empty:before {
            content: attr(placeholder);
            color: #a0a0a0;
        }
    }

    .padding-right-30 {
        padding-right: 30px;
    }

    .input-delete-icon {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
    }

    &.input-has-radius {
        border-radius: 4px;

        input {
            border-radius: 4px;
        }
    }

    .link-input-errorMsg {
      color: #F14;
      margin-top: 5px;
    }
}

</style>
